import { ImageType } from '../../types/featured-link'
import { MarketplaceRetailerLink } from '../../types/marketplace-retailer-link'

function graphqlToMarketplaceRetailerLink(item: any): MarketplaceRetailerLink {
  const logoUrl =
    item?.retailerLogoSet?.tileBackground?.url ||
    item?.retailerLogoSet?.coloured?.url ||
    item?.retailerLogoSet?.transparent?.url ||
    ''
  return {
    imageType: ImageType.square,
    imageUrl: logoUrl,
    logoUrl,
    title: item.title,
    url: `/store/${item.sys.id}/${item.slug}`,
    shortDescription: item.shortDescription,
  }
}

export function graphqlToMarketplaceRetailerReducer(
  items: any[],
  item: any
): MarketplaceRetailerLink[] {
  if (item.marketplaceShopId === null) {
    return items
  }

  return [...items, graphqlToMarketplaceRetailerLink(item)]
}
